/**
 * @generated SignedSource<<0e9931486383f7d425fc6e7957f7a7cb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type deleteAccountModalsFlow_AuthViewerSchemaFragment$data = {
  readonly currentUser: {
    readonly accounts: ReadonlyArray<{
      readonly id: string;
      readonly name: string;
    }>;
  } | null;
  readonly " $fragmentType": "deleteAccountModalsFlow_AuthViewerSchemaFragment";
};
export type deleteAccountModalsFlow_AuthViewerSchemaFragment$key = {
  readonly " $data"?: deleteAccountModalsFlow_AuthViewerSchemaFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"deleteAccountModalsFlow_AuthViewerSchemaFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "deleteAccountModalsFlow_AuthViewerSchemaFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CurrentUser",
      "kind": "LinkedField",
      "name": "currentUser",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Account",
          "kind": "LinkedField",
          "name": "accounts",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AuthViewerSchema",
  "abstractKey": null
};

(node as any).hash = "838fdec608588769ae48d374122e9074";

export default node;
